import React from 'react'

class ExpandableText extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            expanded: false
        }

        this.domRef = React.createRef()
        this.expandCaption = this.expandCaption.bind(this)
    }

    expandCaption() {
        this.setState({
            expanded: true
        })
    }

    render() {
        return (
            <div className="expandable-text">
                <div className={this.state.expanded && 'expanded'}>
                    {this.props.children}
                </div>
                {!this.state.expanded &&
                    <button onClick={this.expandCaption}>
                        <span className="screen-reader-text">Text erweitern</span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                            <rect y="9.9" width="22" height="2.2" />
                            <rect x="9.9" width="2.2" height="22" />
                        </svg>
                    </button>
                }
            </div>
        )
    }
}

export default ExpandableText